document.addEventListener("DOMContentLoaded", () => {
  const header1 = document.querySelector(".shopify-section-group-header-group");
  const header2 = document.querySelector(".gulf-subheader");

  const headerHeight = 
    (header1 ? header1.offsetHeight : 0) +
    (header2 ? header2.offsetHeight : 0);

  const buttons = document.querySelectorAll(".js-scroll-to-btn");
  const scrollContainer = document.querySelector(".gulf-custom-scroll");

  function scrollToContent(btn) {
    const targetId = btn.getAttribute("data-scrollto");
    const target = document.querySelector(`.js-scroll-to-content[data-scrollto="${targetId}"]`);
    if (!target) return;

    // Scroll vertical
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });

    // Actualiza clase active
    buttons.forEach(b => b.classList.remove("active"));
    btn.classList.add("active");

    // Scroll horizontal preciso: botón activo a la izquierda
    const btnRect = btn.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const offset = scrollContainer.scrollLeft + (btnRect.left - containerRect.left);

    scrollContainer.scrollTo({ left: offset, behavior: "smooth" });
  }

  // Click
  buttons.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      scrollToContent(btn);
    });
  });

  // Al cargar la página, alinea el botón activo a la izquierda
  const activeBtn = document.querySelector(".js-scroll-to-btn.active");
  if (activeBtn) scrollToContent(activeBtn);

  // Función para hacer scroll a un target restando header
  function scrollToTarget(targetId) {
    const targetEl = document.querySelector(targetId);
    if (!targetEl) return;

    const header = document.querySelector('.shopify-section-group-header-group');
    let headerHeight = header ? header.offsetHeight : 0;


    const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
    const scrollTo = targetPosition - headerHeight;

    window.scrollTo({
      top: scrollTo,
      behavior: 'smooth'
    });
  }

  // Scroll al hacer clic en enlaces
  document.querySelectorAll('.section-header__hovered-link.js-navigation__link')
  .forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;

      const targetId = href.slice(hashIndex);
      const linkUrl = new URL(href, window.location.origin);
      const samePage = linkUrl.pathname === window.location.pathname;

      if (!samePage) return; // Si es otra página, dejamos que el navegador navegue

      e.preventDefault();

      const scrollAction = () => {
        scrollToTarget(targetId);
        history.pushState(null, '', targetId);
      };

      // Comprobar si el mobile nav está abierto
      if (document.body.classList.contains('reveal-mobile-nav')) {
        // Cerrar nav primero
        document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed');
        setTimeout(() => {
          document.body.classList.remove('enable-mobile-nav-transition');
          scrollAction(); // ejecutar scroll después de cerrar
        }, 200); // tiempo de la transición
      } else {
        // No está abierto, scroll directo
        scrollAction();
      }
    });
  });

// Función scrollToTarget
function scrollToTarget(targetId) {
  const targetEl = document.querySelector(targetId);
  if (!targetEl) return;

  const header = document.querySelector('.shopify-section-group-header-group');
  let headerHeight = header ? header.offsetHeight : 0;

  const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
  const scrollTo = targetPosition - headerHeight;

  window.scrollTo({
    top: scrollTo,
    behavior: 'smooth'
  });
}

// Al cargar la página si hay hash
window.addEventListener('load', () => {
  if (window.location.hash) {
    scrollToTarget(window.location.hash);
  }
});


});